(function($){
    
    
    var videoHtml = function($block){
        $('.video-wrapper').each(function() {
            $(this).find('.video-autoplay').on('inview', function(event, isInView) {
                $(this).trigger(isInView ? 'play' : 'pause');
            });
        });
    }

    
    var videoInview = function( $block ) {
        //https://www.npmjs.com/package/in-view
        inView.threshold(0.25);

        inView(".video-wrapper")
          .on("enter", (el) => el.classList.add("active"))
          .on("exit", (el) => el.classList.remove("active"));
    }
    var videoYoutube = function( $block ){
        /* YouTube Video Embed */
        var $video_icon = $('.video_icon.youtube');
        if ($video_icon.length) {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            $video_icon.on("click", function() {
                var $this = $(this),
                    $youtube_id = $(this).data('youtubeid'),
                    $video_id = $(this).data('videoid'),
                    $parent = $(this).parents('.video_parent.youtube'),
                    player;
                $this.fadeOut(300);
                $this.parent('.video-content.youtube').fadeOut(300);
                player = new YT.Player($video_id, {
                    videoId: $youtube_id,
                    height: $parent.outerHeight(),
                    width: $parent.outerWidth(),
                    playerVars: {rel: 0},
                    events: {
                        'onReady' : onPlayerReady
                    }
                });

            });
        }

        function onPlayerReady(event) {
            event.target.playVideo();
        }
    }
    
    
	/* Document Ready */
	$(document).ready(function() {
        
        videoInview();
        videoYoutube();
        videoHtml();
        
	});
    
    // Initialize dynamic block preview (editor).
    if( window.acf ) {
//        window.acf.addAction( 'render_block_preview', videoInview );
//        window.acf.addAction( 'render_block_preview', videoYoutube );
        window.acf.addAction(
			'render_block_preview/type=video-block',
			videoInview
		);
        window.acf.addAction(
			'render_block_preview/type=video-block',
			videoYoutube
		);
        window.acf.addAction(
			'render_block_preview/type=video-block',
			videoHtml
		);
    }

})(jQuery);